<div *ngIf="root">
  <div class="app-table-search-field">
    <p-inputgroup [style]="{ width: '300px' }">
      <input
        #searchInput
        [style.height]="'40px'"
        pInputText
        [placeholder]="placeholder"
        [ngModel]="searchTerm"
        (ngModelChange)="onSearchInputChange($event)"
        (focus)="focusEvent()"
        fluid />

      <p-inputgroup-addon *ngIf="searchTerm">
        <p-button
          severity="contrast"
          variant="text"
          (click)="clearSearchTerm()"
          type="button">
          <i class="fa-thin fa-xmark"></i>
        </p-button>
      </p-inputgroup-addon>
      <p-inputgroup-addon (click)="onSearchInputChange(searchTerm)">
        <i class="fa-light fa-magnifying-glass"></i>
      </p-inputgroup-addon>
    </p-inputgroup>
  </div>
</div>
<div [ngClass]="{ 'file-explorer-root-wrapper': root }">
  <div
    [ngClass]="{
      'file-explorer-root': root,
      'file-explorer-root-drop-hover':
        root && (dragState.rootDropHover$ | async),
    }"
    (drop)="onRootDrop($event)"
    (dragover)="onRootDragOver($event)"
    (dragenter)="onRootDropZoneDragEnter($event)"
    (dragleave)="onRootDropZoneDragLeave($event)"
    [class.file-explorer-root-droppable]="hasDraggableInTree(items)">
    <ul
      style="position: relative"
      [ngClass]="{
        'file-explorer-root-list': root,
        'file-explorer-background': backgroundColor === 'background',
        'file-explorer-background-contrast': backgroundColor !== 'background',
      }"
      *ngIf="showList || shouldPersistList">
      <li
        *ngFor="let item of items; trackBy: trackByFn"
        (drop)="onItemDrop(item, $event)"
        [draggable]="!root && itemCanDrag(item)"
        (dragstart)="onItemDragged(item, $event)"
        (dragend)="onDragEnd()"
        (dragover)="onDragOver($event)"
        (dragenter)="onRowDragEnter(item, $event)"
        (dragleave)="onRowDragLeave(item, $event)">
        <div
          *ngIf="item.type === 'folder'"
          (click)="onFolderRowClick(item, $event)"
          class="file-explorer-content-container"
          [ngClass]="{
            'file-explorer-item-pending-move': item.moveInProgress,
            'file-explorer-drop-target-hover':
              item.type === 'folder' &&
              (dragState.hoverFolderId$ | async) === item.id,
          }"
          (mouseenter)="hoveredItem = item"
          (mouseleave)="hoveredItem = null">
          <div
            class="file-explorer-content-icon-wrapper"
            [style.min-height]="'16px'">
            <i *ngIf="!item?.expanded" class="fa-regular fa-folder"></i>
            <i *ngIf="item?.expanded" class="fa-regular fa-folder-open"></i>
          </div>
          <div class="file-explorer-content-name-button-wrapper">
            <span
              class="file-explorer-content-name"
              [ngClass]="{
                'file-explorer-content-name-selected':
                  selected && selected === item?.id,
              }">
              <span
                [pTooltip]="item.tooltip| truncate:400 | sanitizeHtmlTooltip"
                [escape]="false"
                tooltipPosition="right"
                [showDelay]="100">
                {{ item.name }}
              </span></span
            >
            <span
              class="file-explorer-content-drag-handle"
              *ngIf="itemCanDrag(item)"
              aria-hidden="true">
              <i class="fa-solid fa-grip-lines"></i>
            </span>
            <span
              class="file-explorer-menu-btn"
              (click)="handleToggleMenu($event, item)"
              *ngIf="item.menuItems?.length && !item.moveInProgress"
              [style.min-width]="'14px'"
              [style.visibility]="hoveredItem === item ? 'visible' : 'hidden'">
              <i class="fa-solid fa-ellipsis"></i>
            </span>
          </div>
        </div>

        <ul *ngIf="item.type === 'folder' && item.children && item.expanded">
          <app-file-explorer-input
            [(menuState)]="menuState"
            (toggleMenu)="handleToggleMenu($event.event, $event.item)"
            [showList]="true"
            [avoidDrag]="avoidDrag"
            [backgroundColor]="backgroundColor"
            [root]="false"
            [items]="item.children"
            [selected]="selected"
            (itemClicked)="onItemClick($event)"
            (itemDropped)="handleItemDropped($event)"></app-file-explorer-input>
        </ul>
        <span
          [showDelay]="100"
          class="file-explorer-content-container file-explorer-file"
          [ngClass]="{ 'file-explorer-item-pending-move': item.moveInProgress }"
          *ngIf="item.type !== 'folder'"
          (click)="onItemClick(item)"
          (mouseenter)="hoveredItem = item"
          (mouseleave)="hoveredItem = null">
          <ng-container [ngSwitch]="item?.type">
            <div class="file-explorer-content-icon-wrapper">
              <i *ngSwitchCase="'book'" class="fa-regular fa-book"></i>

              <i *ngSwitchCase="'workbook'" class="fa-regular fa-notebook"></i>
              <app-loading-dots
                *ngSwitchCase="'loading'"
                size="5px"></app-loading-dots>
              <i *ngSwitchDefault class="fa-regular fa-file-code"></i>
            </div>
          </ng-container>
          <div class="file-explorer-content-name-button-wrapper">
            <span
              class="file-explorer-content-name"
              [ngClass]="{
                'file-explorer-content-name-selected':
                  selected && selected === item?.id,
                'active-item-menu': item?.id == menuState?.item?.id,
                'inactive-item-menu': item?.id != menuState?.item?.id,
              }">
              <span
                tooltipPosition="right"
                [tooltipEvent]="!item?.tooltip ? 'noop' : 'hover'"
                [pTooltip]="item.tooltip | truncate:400 | sanitizeHtmlTooltip"
                [escape]="false">
                {{ item.name }}
              </span>
            </span>
            <span
              class="file-explorer-content-drag-handle"
              *ngIf="itemCanDrag(item)"
              aria-hidden="true">
              <i class="fa-solid fa-grip-lines"></i>
            </span>
            <span
              class="file-explorer-menu-btn"
              (click)="handleToggleMenu($event, item)"
              *ngIf="item.menuItems?.length && !item.moveInProgress"
              [style.min-width]="'14px'"
              [style.visibility]="hoveredItem === item ? 'visible' : 'hidden'">
              <i class="fa-solid fa-ellipsis"></i>
            </span>
          </div>
        </span>
      </li>
    </ul>
  </div>
</div>
<!-- first level menu-->
<ng-container *ngIf="root">
  <div
    class="file-explorer-menu"
    *ngIf="menuState?.isOpen"
    [ngStyle]="{ top: menuState.top, left: menuState.left }">
    <ul>
      <li
        tooltipPosition="right"
        [pTooltip]="menuItem?.tooltip | truncate:400 | sanitizeHtmlTooltip"
        [escape]="false"
        [ngClass]="{
          'file-explorer-menu-item-disabled': menuItem?.disabled,
          'file-explorer-menu-item-enabled': !menuItem?.disabled,
        }"
        *ngFor="let menuItem of menuState.item?.menuItems"
        (click)="handleMenuItemClicked($event, menuItem)"
        (mouseenter)="
          menuItem.menuItems ? openSubmenu($event, menuItem) : closeSubmenu()
        ">
        <span>
          {{ menuItem.label }}
        </span>
        <span *ngIf="!menuItem?.disabled && menuItem.menuItems?.length"
          ><i style="font-size: 11px" class="fa-regular fa-chevron-right"></i
        ></span>
      </li>
    </ul>
  </div>
</ng-container>

<!--second level menu --- not super scalable but how many more levels should we add? -->
<ng-container *ngIf="root">
  <div
    class="file-explorer-submenu"
    *ngIf="submenuState?.isOpen"
    [ngStyle]="{ top: submenuState.top, left: submenuState.left }">
    <ul>
      <li
        tooltipPosition="right"
        [pTooltip]="subItem?.tooltip | truncate:400 | sanitizeHtmlTooltip"
        [escape]="false"
        [ngClass]="{
          'file-explorer-menu-item-disabled': subItem?.disabled,
          'file-explorer-menu-item-enabled': !subItem?.disabled,
        }"
        *ngFor="let subItem of submenuState.item?.menuItems"
        (click)="handleMenuItemClicked($event, subItem)">
        <span>{{ subItem.label }}</span>
      </li>
    </ul>
  </div>
</ng-container>
